<template lang="pug">
.container-fluid
	div(v-if="!evento.EventoID")
		h1 Evento no encontrado
	div(v-else)
		// Cabecera
		.mb-2(v-if="evento.ImagenCabecera")
			img(:src="'/src/modulos/eventos/php/api/getImagen.php?imagen=' + evento.ImagenCabecera", style="width:100%;")
		.mb-2(v-if="evento.PublicID", ref="cabecera")
			button.m-1.btn.btn-warning(@click="upload('cabecera')")
				span.fa.fa-photo.mr-2
				| Cambiar imagen de cabecera
			button.m-1.btn.btn-warning(@click="upload('invitacion')")
				span.fa.fa-photo.mr-2
				| Cambiar imagen de invitación
			button.m-1.btn.btn-warning(@click="upload('cartel')")
				span.fa.fa-photo.mr-2
				| Cambiar imagen del cartel
		// Capa con la información básica
		.row
			.col-xs-12.col-sm-12.col-md-6.col-lg-6.col-xl-6
				.card
					.card-header.bg-info.text-white
						span.fa.fa-info.mr-2
						| Información básica
					.card-body
						p
							button.m-1.btn.btn-primary(v-if="evento.ImagenInvitacion", @click="verImagen('ImagenInvitacion')")
								span.fa.fa-photo.mr-2
								| Ver diseño de invitación
							button.m-1.btn.btn-primary(v-if="evento.ImagenCartel", @click="verImagen('ImagenCartel')")
								span.fa.fa-photo.mr-2
								| Ver diseño del cartel
						.form-group
							label Título del evento
							input.form-control.form-control-lg(v-model="evento.Titulo")
						.form-group
							label Descripción del evento
							textarea.form-control(v-model="evento.Descripcion", rows="5")
						.form-group
							label Lugar del evento
							input.form-control(v-model="evento.Lugar")
						.form-group
							label Fecha y hora de inicio del evento
							.input-group
								.input-group-prepend
									.input-group-text Fecha
								input.form-control(v-mask="'##-##-####'", v-model="FechaInicio")
								.input-group-append
									.input-group-text Hora
								input.form-control(v-mask="'##:##'", v-model="HoraInicio")

						.form-group
							label Fecha y hora de fin del evento
							.input-group
								.input-group-prepend
									.input-group-text Fecha
								input.form-control(v-mask="'##-##-####'", v-model="FechaFin")
								.input-group-append
									.input-group-text Hora
								input.form-control(v-mask="'##:##'", v-model="HoraFin")
					.card-body.bg-light(v-if="evento.PublicID")
						h4
							b ID público:
							|  {{evento.PublicID}}
					.card-footer
						button.btn.btn-primary(@click="guardar")
							span.fa.fa-save.mr-2
							| Guardar

			.col-xs-12.col-sm-12.col-md-6.col-lg-6.col-xl-6
				.card
					.card-header.bg-dark.text-white
						span.fa.fa-group.mr-2
						| Asistentes

					.card-body
						.row
							.col-xs-12.col-sm-6.col-md-6.col-lg-6.col-xl-6
								.form-group
									label Nº máximo de asistentes
									input.form-control(placeholder="En blanco no hay límite", v-model="evento.MaximoInscripciones")
							.col-xs-12.col-sm-6.col-md-6.col-lg-6.col-xl-6
								.form-group
									label Nº máximo de asistentes por registro
									input.form-control(placeholder="En blanco no hay límite", v-model="evento.MaximoInscritosEmail")

						.form-group
							label Tipo de registro
							br
							.btn-group
								button.btn(:class="(evento.SoloInvitacion) ? '' : 'btn-primary'", @click="evento.SoloInvitacion = false") Abierto
								button.btn(:class="(evento.SoloInvitacion) ? 'btn-primary' : ''", @click="evento.SoloInvitacion = true") Solo con invitación

						.form-group
							label Fecha y hora de inicio de inscripciones
							.input-group
								.input-group-prepend
									.input-group-text Fecha
								input.form-control(v-mask="'##-##-####'", v-model="FechaInicioInscripciones")
								.input-group-append
									.input-group-text Hora
								input.form-control(v-mask="'##:##'", v-model="HoraInicioInscripciones")

						.form-group
							label Fecha y hora de fin de inscripciones
							.input-group
								.input-group-prepend
									.input-group-text Fecha
								input.form-control(v-mask="'##-##-####'", v-model="FechaFinInscripciones")
								.input-group-append
									.input-group-text Hora
								input.form-control(v-mask="'##:##'", v-model="HoraFinInscripciones")
					.card-body.bg-light
						h5 LOPD
						vue-mce.editor(:config="configuracionEditor", v-model="evento.LOPD")
	VistaPrevia(v-if="preview", :tipo="preview", :evento.sync="evento", @cerrar="preview=null")
</template>


<script>
import VistaPrevia from './vistaPrevia'
export default {
	components: {
		VistaPrevia
	},
	data () {
		return {
			evento: {
				EventoID: null,
				PublicID: null,
				Activo: true,
				Titulo: null,
				Descripcion: null,
				Lugar: null,
				FechaInicioEvento: new Date(),
				FechaFinEvento: new Date(),
				FechaInicioInscripciones: new Date(),
				FechaFinInscripciones: new Date(),
				MaximoInscritosEmail: null,
				MaximoInscripciones: null,
				SoloInvitacion: null,
				FechaCreacion: new Date(),
				LOPD: '',
				ImagenCabecera: null,
				ImagenInvitacion: null,
				ImagenCartel: null
			},
			FechaInicio: null,
			HoraInicio: null,
			FechaFin: null,
			HoraFin: null,
			FechaInicioInscripciones: null,
			HoraInicioInscripciones: null,
			FechaFinInscripciones: null,
			HoraFinInscripciones: null,
			configuracionEditor: {
				menubar: false,
				theme: 'modern',
				plugins: [
					'advlist autolink lists link image charmap print preview anchor textcolor',
					'searchreplace visualblocks code fullscreen',
					'insertdatetime media table contextmenu paste code help wordcount paste'
				],
				toolbar: 'insert paste | undo redo |  formatselect | bold italic | alignleft aligncenter alignright alignjustify | table | bullist numlist outdent indent | removeformat',
				paste_as_text: true,
				table_default_attributes: {
					'border': '1'
				},
				table_default_styles: {
					'border-collapsed': 'collapse',
					'width': '100%'
				},
				table_responsive_width: true,
				content_style: `
					table {width: 100%;border-spacing: 0;border-collapse: separate;border: 1px solid #aaa;}
					table tr:nth-child(even) {background-color: #fafafa;}
					table td, table th {border: 1px solid #aaa; border-collapse:collapse;padding: 5px;}
				`
			},
			preview: null
		}
	},
	created () {
		if (this.$route.params.id) {
			this.getEvento(this.$route.params.id)
		} else {
			this.nuevo()
		}
	},
	watch: {
		FechaInicio (newVal) {
			if (newVal.length < 10) {
				return
			}

			this.evento.FechaInicioEvento = (!this.evento.FechaInicioEvento) ? new Date() : this.evento.FechaInicioEvento

			const f = newVal.split('-')
			this.evento.FechaInicioEvento.setYear(parseInt(f[2]))
			this.evento.FechaInicioEvento.setMonth(parseInt(f[1] - 1))
			this.evento.FechaInicioEvento.setDate(parseInt(f[0]))
		},
		HoraInicio (newVal) {
			if (newVal.length < 5) {
				return
			}

			this.evento.FechaInicioEvento = (!this.evento.FechaInicioEvento) ? new Date() : this.evento.FechaInicioEvento

			const f = newVal.split(':')
			this.evento.FechaInicioEvento.setHours(parseInt(f[0]))
			this.evento.FechaInicioEvento.setMinutes(parseInt(f[1]))
		},
		FechaFin (newVal) {
			if (newVal.length < 10) {
				return
			}

			this.evento.FechaFinEvento = (!this.evento.FechaFinEvento) ? new Date() : this.evento.FechaFinEvento

			const f = newVal.split('-')
			this.evento.FechaFinEvento.setYear(parseInt(f[2]))
			this.evento.FechaFinEvento.setMonth(parseInt(f[1] - 1))
			this.evento.FechaFinEvento.setDate(parseInt(f[0]))
		},
		HoraFin (newVal) {
			if (newVal.length < 5) {
				return
			}

			this.evento.FechaFinEvento = (!this.evento.FechaFinEvento) ? new Date() : this.evento.FechaFinEvento

			const f = newVal.split(':')
			this.evento.FechaFinEvento.setHours(parseInt(f[0]))
			this.evento.FechaFinEvento.setMinutes(parseInt(f[1]))
		},
		FechaInicioInscripciones (newVal) {
			if (newVal.length < 10) {
				return
			}

			this.evento.FechaInicioInscripciones = (!this.evento.FechaInicioInscripciones) ? new Date() : this.evento.FechaInicioInscripciones

			const f = newVal.split('-')
			this.evento.FechaInicioInscripciones.setYear(parseInt(f[2]))
			this.evento.FechaInicioInscripciones.setMonth(parseInt(f[1] - 1))
			this.evento.FechaInicioInscripciones.setDate(parseInt(f[0]))
		},
		HoraInicioInscripciones (newVal) {
			if (newVal.length < 5) {
				return
			}

			this.evento.FechaInicioInscripciones = (!this.evento.FechaInicioInscripciones) ? new Date() : this.evento.FechaInicioInscripciones

			const f = newVal.split(':')
			this.evento.FechaInicioInscripciones.setHours(parseInt(f[0]))
			this.evento.FechaInicioInscripciones.setMinutes(parseInt(f[1]))
		},
		FechaFinInscripciones (newVal) {
			if (newVal.length < 10) {
				return
			}

			this.evento.FechaFinInscripciones = (!this.evento.FechaFinInscripciones) ? new Date() : this.evento.FechaFinInscripciones

			const f = newVal.split('-')
			this.evento.FechaFinInscripciones.setYear(parseInt(f[2]))
			this.evento.FechaFinInscripciones.setMonth(parseInt(f[1] - 1))
			this.evento.FechaFinInscripciones.setDate(parseInt(f[0]))
		},
		HoraFinInscripciones (newVal) {
			if (newVal.length < 5) {
				return
			}

			this.evento.FechaFinInscripciones = (!this.evento.FechaFinInscripciones) ? new Date() : this.evento.FechaFinInscripciones

			const f = newVal.split(':')
			this.evento.FechaFinInscripciones.setHours(parseInt(f[0]))
			this.evento.FechaFinInscripciones.setMinutes(parseInt(f[1]))
		}
	},
	methods: {
		nuevo () {
			this.evento.EventoID = 'nuevo'
		},
		getEvento (id) {
			this.$http.post('eventos/php/api/getEvento.php', {EventoID: id})
				.then(res => {
					res.data.FechaInicioEvento = (res.data.FechaInicioEvento) ? new Date(res.data.FechaInicioEvento * 1000) : null
					res.data.FechaFinEvento = (res.data.FechaFinEvento) ? new Date(res.data.FechaFinEvento * 1000) : null
					res.data.FechaInicioInscripciones = (res.data.FechaInicioInscripciones) ? new Date(res.data.FechaInicioInscripciones * 1000) : null
					res.data.FechaFinInscripciones = (res.data.FechaFinInscripciones) ? new Date(res.data.FechaFinInscripciones * 1000) : null
					this.evento = res.data

					// Parseamos la fecha
					if (this.evento.FechaInicioEvento) {
						this.FechaInicio = this.$moment(res.data.FechaInicioEvento).format('DD-MM-YYYY')
						this.HoraInicio = this.$moment(res.data.FechaInicioEvento).format('HH:mm')
					}

					if (this.evento.FechaFinEvento) {
						this.FechaFin = this.$moment(res.data.FechaFinEvento).format('DD-MM-YYYY')
						this.HoraFin = this.$moment(res.data.FechaFinEvento).format('HH:mm')
					}

					if (this.evento.FechaInicioInscripciones) {
						this.FechaInicioInscripciones = this.$moment(res.data.FechaInicioInscripciones).format('DD-MM-YYYY')
						this.HoraInicioInscripciones = this.$moment(res.data.FechaInicioInscripciones).format('HH:mm')
					}

					if (this.evento.FechaFinInscripciones) {
						this.FechaFinInscripciones = this.$moment(res.data.FechaFinInscripciones).format('DD-MM-YYYY')
						this.HoraFinInscripciones = this.$moment(res.data.FechaFinInscripciones).format('HH:mm')
					}
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		guardar () {
			if (!this.evento.Titulo) {
				this.error('Debes definir el título')
				return
			}

			if (!this.evento.Lugar) {
				this.error('Debes definir el lugar del evento')
				return
			}

			if (!this.evento.FechaInicioEvento) {
				this.error('Debes definir la fecha de inicio del evento')
				return
			}

			if (!this.evento.FechaFinEvento) {
				this.error('Debes definir la fecha de fin del evento')
				return
			}

			if (!this.evento.FechaInicioInscripciones) {
				this.error('Debes definir la fecha de inicio de las inscripciones')
				return
			}

			if (!this.evento.FechaFinInscripciones) {
				this.error('Debes definir la fecha de fin de las inscripciones')
				return
			}

			if (!this.evento.LOPD || !this.evento.LOPD.trim()) {
				this.error('Debes escribir las cláusulas de protección de datos')
				return
			}

			const form = JSON.parse(JSON.stringify(this.evento))
			form.FechaInicioEvento = Math.floor(this.evento.FechaInicioEvento.getTime() / 1000)
			form.FechaFinEvento = Math.floor(this.evento.FechaFinEvento.getTime() / 1000)
			form.FechaInicioInscripciones = Math.floor(this.evento.FechaInicioInscripciones.getTime() / 1000)
			form.FechaFinInscripciones = Math.floor(this.evento.FechaFinInscripciones.getTime() / 1000)

			this.$http.post('eventos/php/api/setEvento.php', form)
				.then(res => {
					this.getEvento(res.data.EventoID)

					this.$store.commit('toast/success', {
						titulo: 'Cambios guardados',
						mensaje: 'Evento actualizado correctamente'
					})
				})
				.catch(e => {
					this.error(e.response.data.error)
				})
		},
		error (msj) {
			this.$store.commit('alertas/error', {
				titulo: 'Error',
				mensaje: msj
			})
		},
		upload (tipo) {
			const inp = document.createElement('input')
			inp.type = 'file'
			inp.accept = '.jpg'
			inp.style.display = 'none'

			inp.addEventListener('change', () => {
				const form = new FormData()
				form.append('EventoID', this.evento.EventoID)
				form.append('Tipo', tipo)
				form.append('fichero', inp.files[0])

				this.$http.post('eventos/php/api/setImagen.php', form)
					.then(res => {
						this.getEvento(this.evento.EventoID)
					})
					.catch(e => {
						this.error(e.response.data.error)
					})
				this.$refs.cabecera.removeChild(inp)
			})

			inp.addEventListener('blur', () => {
				console.log('Cancelado')
			})

			this.$refs.cabecera.appendChild(inp)
			inp.click()
		},
		verImagen (nombre) {
			this.preview = nombre
		}
	}
}
</script>
<style scoped>
.editor {
}
</style>



// WEBPACK FOOTER //
// src/modulos/eventos/vue/components/editor/editor.vue